// extracted by mini-css-extract-plugin
module.exports = {"terms":"terms_terms__3C3Y9","terms__inner":"terms_terms__inner__2MCr-","terms__title":"terms_terms__title__2dmfj","terms__body":"terms_terms__body__Mf8wN"};